/**
 * COMPARE_ROW_ID — identifiers for all possible rows in the FavoritesView comparison columns.
 *
 * Each ID maps to one entry in COMPARE_ROW_REGISTRY (see utils/compareRows.js).
 * Adding a new displayable data point, action etc.: add a constant here + a registry entry there.
 */
export const COMPARE_ROW_ID = {
  //GROUP PLACEHOLDERS
  ADDITIONAL_AREAS_GROUP: 'additional_areas_group',
  ADDITIONAL_DATA_GROUP: 'additional_data_group',
  //DATA FIELDS
	AREA: 'area',
	AREA_PERCENTILE: 'area_percentile',
	INVESTMENT: 'investment',
	BUILDING: 'building',
	// ENERGY_CLASS:    'energy_class',
	// ENERGY_USEFUL:   'energy_useful', //EU
	// ENERGY_FINAL:    'energy_final', //EK
	// ENERGY_PRIMARY:  'energy_primary' //EP
	// ENERGY_RENEWABLE_SHARE: 'energy_renewable_share', //Uoze
	// ENERGY_CO2_EMISSIONS: 'energy_co2_emissions' //Eco2
	// ENERGY_HEATING_COST_NOW: 'energy_heating_cost_now',
	// ENERGY_HEATING_COST_10Y: 'energy_heating_cost_10y',
	EXPOSITION: 'exposition',
	FLAGS: 'flags',
	FLOOR: 'floor',
	GATE: 'gate',
	HEIGHT: 'height',
	INSOLATION_HOURS: 'insolation_hours',
	INSOLATION_RANGE: 'insolation_range',
	INQUIRY_CTA: 'inquiry_cta',
	LEVELS: 'levels',
	LOT_AREA: 'lot_area',
	OPEN_CTA: 'open_cta',
	OUTDOOR_AREAS: 'outdoor_areas',
	PLAN_THUMB: 'plan_thumb',
	PRICE: 'price',
	PRICE_M2: 'price_m2',
	PRODUCT_CATEGORY: 'product_category',
	ROOMS: 'rooms',
	SPECIAL_AREAS: 'special_areas',
	STAGE: 'stage',
	STATUS: 'status',
	TURN_KEY_STYLE: 'turn_key_style',
};
